import React from 'react';
import { createComponent } from '@lit/react';
import { IxProgress as LitComp } from '../IxProgress.js';

customElements.define('ix-progress', LitComp);

export const IxProgress = createComponent({
  tagName: 'ix-progress-react',
  elementClass: LitComp,
  react: React,
});
